/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import { Modal } from "react-bootstrap";
import BaseCom from "./BaseCom";
import { qreq } from "../shared/qrequest";
import L from "./Lang";

export const AI = {
    pretty: async (input, callback) => { }
}

export default class AIPretty extends BaseCom {
    constructor(props) {
        super(props);
        this.state = {
            input: null
        };
        AI.pretty = this.show;
    }

    show = async (input, callback) => {
        this.setState({ show: true, input: input, callback: callback, done: false });
        await this.prettify(input);
    }

    hide = () => {
        this.setState({ show: false, callback: null });
    }

    prettify = async (input) => {
        this.setState({ processing: true });
        try {
            let j = await qreq.postAsync('/api/ai/prettify', { input: input });
            if (j.item)
                this.setState({ input: j.item, done: true });
            else {
                this.alert(j.errorMessage);
                this.hide();
            }
        }
        catch {
            this.unkownErrorCallback();
            this.hide();
        }
        this.setState({ processing: false });
    }

    accept = () => {
        this.state.callback(this.state.input);
        this.hide();
    }

    render() {
        return <Modal show={this.state.show} onHide={this.hide}>
            <Modal.Header closeButton>
                <Modal.Title>Make me Pretty :]</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <textarea className={'form-control ' + (this.state.processing ? 'process-bg' : '')} rows="10" value={this.state.input} readOnly></textarea>
            </Modal.Body>
            {this.state.done && <Modal.Footer>
                <button className="btn btn-primary" onClick={this.accept}><L>Accept</L></button>
                <button className="btn btn-secondary" onClick={this.hide}><L>Close</L></button>
            </Modal.Footer>}
        </Modal>;
    }
}